import { Flex, createStyles } from '@mantine/core';

import { EDGE_BOOST_TILE_ICON_SIZE } from '../constants';

const LOGO_ASPECT_RATIO = 535.24 / 254.98;

const useStyles = createStyles((theme) => ({
  plate: {
    borderRadius: theme.radius.sm,
  },
}));

type EdgeBoostIconProps = {
  size?: string | number;
};

export function EdgeBoostIcon({ size = EDGE_BOOST_TILE_ICON_SIZE }: EdgeBoostIconProps) {
  const { classes, theme } = useStyles();
  const logoHeight = Number(size);

  return (
    <Flex
      className={classes.plate}
      align="center"
      justify="center"
      bg={theme.black}
      px={theme.other.spacing._6}
      py={theme.other.spacing._4}
    >
      <svg
        viewBox="0 0 535.24 254.98"
        aria-hidden
        height={logoHeight}
        width={logoHeight * LOGO_ASPECT_RATIO}
      >
        <path
          fill="#12a1e8"
          d="M78.46,73.77v.02H23.81v23.48h95.22l-10.69,24.94H0V48.83h89.15l-10.7,24.94ZM198.45,0c4.33,0,8.57.49,12.65,1.36h.02c27.42,5.87,48.01,30.39,48.01,59.75s-20.59,53.89-48.01,59.75c-4.08.87-8.32,1.36-12.65,1.36h-60.51V48.81h24.96v47.94h39.67c17.71-2.05,31.52-16.5,31.52-35.64s-14.96-34.77-33.68-35.81h-62.49V0h60.51ZM397.28,0v25.33h-62.49c-18.74,1.04-33.68,17.43-33.68,35.81s13.81,33.56,31.52,35.64h39.67v-47.94h24.98v73.39h-60.51c-4.35,0-8.57-.49-12.65-1.36-27.42-5.86-48.01-30.38-48.01-59.75,0-29.37,20.59-53.89,48.01-59.75C328.19.49,332.44,0,336.77,0h60.51ZM494.5,73.41l-.04.02h-54.44v23.48h95.22l-10.7,24.94h-108.31V48.47h88.96l-10.7,24.94ZM108.31,25.33H0V0h119.01l-10.69,25.33ZM524.54,25.33h-108.33V0h119.03l-10.69,25.33Z"
        />
        <path
          fill="#ffcd00"
          d="M84.39,203.77c-2.81-4.42-6.94-7.66-12.42-9.7,3.59-1.89,6.32-3.98,8.15-6.27,3.29-4.08,4.95-9.47,4.95-16.2s-1.66-12.1-4.95-16.79c-5.49-7.62-14.8-11.51-27.97-11.72H0v110h48.67c5.49,0,10.56-.5,15.25-1.49,4.69-.99,8.76-2.84,12.2-5.53,3.05-2.33,5.62-5.22,7.66-8.65,3.2-5.16,4.8-11.02,4.8-17.53s-1.39-11.69-4.18-16.13v.02ZM58.79,232.05c-2.62,1.3-6.29,1.94-11.01,1.94h-26.35v-29.33h26.74c4.65.06,8.28.67,10.84,1.87,4.61,2.13,6.92,6.08,6.92,11.8,0,6.77-2.38,11.34-7.14,13.72ZM56.89,184.84c-2.49,1.07-5.97,1.6-10.45,1.6h-25.01v-24.24h25.39c4.43.04,7.85.55,10.3,1.54,4.39,1.77,6.56,5.01,6.56,9.76,0,5.6-2.25,9.38-6.79,11.36v-.02Z"
        />
        <path
          fill="#ffcd00"
          d="M441.95,143.08v22.82h35.17v87.17h22.11v-87.17h26.81l9.2-22.82h-93.29Z"
        />
        <path
          fill="#ffcd00"
          d="M191.2,153.74c-8.2-8.35-20.03-12.53-35.53-12.53s-27.35,4.18-35.54,12.53c-10.98,9.87-16.47,24.66-16.47,44.33s5.49,34.08,16.47,44.33c8.2,8.36,20.03,12.53,35.54,12.53s27.35-4.2,35.53-12.53c10.93-10.26,16.4-25.03,16.4-44.33s-5.47-34.47-16.4-44.33ZM177.07,226.08c-5.3,6.57-12.43,9.85-21.42,9.85s-16.14-3.28-21.48-9.85c-5.34-6.57-8.01-15.89-8.01-28.01s2.67-21.43,8.01-28.01c5.34-6.57,12.51-9.85,21.48-9.85s16.1,3.3,21.36,9.89c5.27,6.58,7.92,15.91,7.92,27.98s-2.63,21.43-7.88,28.01h.02Z"
        />
        <path
          fill="#ffcd00"
          d="M310.31,153.74c-8.2-8.36-20.03-12.53-35.53-12.53s-27.34,4.18-35.54,12.53c-10.98,9.87-16.47,24.66-16.47,44.33s5.49,34.08,16.47,44.33c8.2,8.36,20.03,12.53,35.54,12.53s27.35-4.2,35.53-12.53c10.93-10.26,16.4-25.03,16.4-44.33s-5.47-34.47-16.4-44.33ZM296.2,226.09c-5.3,6.56-12.45,9.85-21.42,9.85s-16.14-3.28-21.48-9.85c-5.34-6.57-8.01-15.89-8.01-28.01s2.67-21.43,8.01-28.01c5.34-6.57,12.51-9.85,21.48-9.85s16.1,3.3,21.36,9.88c5.26,6.58,7.92,15.91,7.92,27.98s-2.63,21.43-7.86,28.01Z"
        />
        <path
          fill="#ffcd00"
          d="M419.24,198.65c-4.18-3.26-10.34-5.88-18.54-7.83l-18.68-4.46c-7.2-1.7-11.92-3.19-14.12-4.48-3.44-1.9-5.15-4.78-5.15-8.64,0-4.2,1.75-7.46,5.23-9.81,3.18-2.13,6.98-2.98,10.76-3.34,7.09-.71,14.37.67,20.71,3.86,3.1,1.57,5.87,3.62,8.52,5.86,1.54,1.29,5.36,4.81,5.27,4.68-.09-.13,9.33-15.82,9.33-15.82-2.16-3.13-4.98-5.86-8.44-8.43-8.07-6.02-19.16-9.07-30.6-9.07-13.69,0-24.05,3.19-31.12,9.59-7.07,6.4-10.61,14.42-10.61,24.08,0,10.59,3.67,18.37,10.96,23.33,4.31,2.98,12.11,5.73,23.39,8.26l11.47,2.57c6.71,1.45,11.66,3.15,14.78,5.05,3.14,1.96,4.7,4.7,4.7,8.26,0,6.1-3.16,10.28-9.5,12.51-3.33,1.18-7.67,1.75-13.03,1.75-8.91,0-15.23-2.22-18.9-6.66-2.01-2.44-3.35-6.12-4.04-11.04h-21.63c0,11.23,4.04,20.03,12.13,26.45,8.09,6.42,19.2,9.62,33.32,9.62s24.54-3.26,32.12-9.77,11.36-14.7,11.36-24.54-3.24-16.95-9.7-22.03l.02.02Z"
        />
      </svg>
    </Flex>
  );
}
